import type { FlowEdge, FlowNode } from '../types/flow-types';

export interface FlowIsland {
	id: string;
	name: string;
	rootNodeId: string;
	nodeIds: string[];
	edgeIds: string[];
}

export function deriveFlowIslands(nodes: FlowNode[], edges: FlowEdge[]): FlowIsland[] {
	const semantic = nodes.filter((node) => node.type !== 'note');
	const ids = new Set(semantic.map((node) => node.id));
	const neighbors = new Map([...ids].map((id) => [id, new Set<string>()]));
	const incoming = new Map([...ids].map((id) => [id, 0]));
	for (const edge of edges) {
		if (!ids.has(edge.source) || !ids.has(edge.target)) continue;
		neighbors.get(edge.source)?.add(edge.target);
		neighbors.get(edge.target)?.add(edge.source);
		incoming.set(edge.target, (incoming.get(edge.target) ?? 0) + 1);
	}
	const visited = new Set<string>();
	const islands: FlowIsland[] = [];
	for (const node of semantic) {
		if (visited.has(node.id)) continue;
		const nodeIds: string[] = [];
		const queue = [node.id];
		while (queue.length) {
			const id = queue.shift()!;
			if (visited.has(id)) continue;
			visited.add(id);
			nodeIds.push(id);
			queue.push(...(neighbors.get(id) ?? []));
		}
		const rootNodeId =
			nodeIds.find((id) => (incoming.get(id) ?? 0) === 0) ?? nodeIds.slice().sort()[0];
		const root = semantic.find((item) => item.id === rootNodeId)!;
		islands.push({
			id: rootNodeId,
			rootNodeId,
			name: String(root.data.islandName || '').trim() || `Automation ${islands.length + 1}`,
			nodeIds,
			edgeIds: edges
				.filter((edge) => nodeIds.includes(edge.source) && nodeIds.includes(edge.target))
				.map((edge) => edge.id),
		});
	}
	return islands;
}
